import OrderingTaskForm from './ordering-task-form'

export default OrderingTaskForm
